import { z } from "zod";
import {
  JobTaskSchema,
  createJobTaskSchema,
  updateJobTaskSchema,
} from "@/lib/validations/business/job-task";

/** Fields that can be edited in a job task */
export type JobTaskEditableField =
  | "title"
  | "description"
  | "instructions"
  | "estimated_duration"
  | "equipment_id";

/** Interface defining permissions for job task fields */
export interface JobTaskFieldPermissions {
  editable: JobTaskEditableField[];
  viewable: JobTaskEditableField[];
}

/** Fields that can be used for sorting job tasks */
export const JobTaskSortable = [
  "title",
  "estimated_duration",
  "created",
  "updated",
] as const;
export type JobTaskSortField = (typeof JobTaskSortable)[number];

/** Complete job task type with all fields */
export type JobTask = z.infer<typeof JobTaskSchema>;

/** Type for creating a new job task */
export type CreateJobTaskInput = z.infer<typeof createJobTaskSchema>;

/** Type for updating an existing job task */
export type UpdateJobTaskInput = z.infer<typeof updateJobTaskSchema>;

/** Simplified job task type for lists */
export interface SimpleJobTask {
  id: string;
  title: string;
}
